import { profileState } from "@/atoms/user/profile-state";
import { UserRole } from "@/common/enum/user-role";
import { userService } from "@/services/user-service";
import * as ChannelService from "@channel.io/channel-web-sdk-loader";
import { useEffect } from "react";
import { useRecoilValue } from "recoil";
import { GlobalAdminHeader } from "./GlobalAdminHeader";
import { GlobalPartnerHeader } from "./GlobalPartnerHeader";
import { GlobalSUHeader } from "./GlobalSUHeader";

interface Props {}

export const GlobalHeader: React.FC<Props> = ({}) => {
  const profile = useRecoilValue(profileState);

  ChannelService.loadScript();
  useEffect(() => {
    (async () => {
      const { data: memberHash } = await userService.getChannelTalkMemberHash();
      ChannelService.boot({
        pluginKey: "9a3034ae-8805-44a1-8cb3-8c7700c46678",
        memberId: `${profile.id}`,
        memberHash: memberHash,
        profile: {
          name: profile.name,
          mobileNumber: profile.phone,
          customField1: profile.businessName,
          customField2: profile.email,
        },
      });
    })();
  }, []);

  if (profile.role === UserRole.SUPERUSER) {
    return <GlobalSUHeader />;
  }

  if (profile.role === UserRole.ADMIN) {
    return <GlobalAdminHeader />;
  }

  return <GlobalPartnerHeader />;
};
